<div fxLayout="row" fxLayout.sm="column" fxLayoutAlign="center center" class="history" *ngFor="let item of history">
  <div fxFlex="33">
    <h3>{{item.updatedBy}}</h3>
    <h4>{{item.updated | date: 'yyyy/MM/dd HH:mm:ss'}}</h4>
  </div>
  <div class="changeStatus">
    <span>
      {{item.oldStatusName}}
      <mat-icon>arrow_forward</mat-icon>
      {{item.newStatusName}}
    </span>
  </div>
  <h5 fxFlex>{{item.comment}}</h5>
</div>
